import {
  Defaults,
  Traits
} from './shared';

import { ICON_BUTTON_APP_PAGE } from './../../../const/icons';

import { COMP_BUTTON_APP_PAGE } from './../../../const/components';

import { FIELD_APP_PAGE_SELECTOR } from './../../../const/traits';

import { PageFormLinkedItem } from './../page-form-linked-item';

export const AppPage = (editor, options:any = {}) => {

  (FIELD_APP_PAGE_SELECTOR as any).at = 9;

  return PageFormLinkedItem(editor, {
    componentName: COMP_BUTTON_APP_PAGE,
    displayIcon: ICON_BUTTON_APP_PAGE,
    model: {
      defaults: { ...Defaults,
        name: 'App Page',
        traits: [ ...Traits, FIELD_APP_PAGE_SELECTOR]
      }
    }
  });
}